<template>
  <zen-one 
    :showuserinfo="false" 
    title=""
    :crumbs="crumbs"
  >
    <z-page title="Kemaskini Kata Laluan">

      <w-flex justify-center>
        <w-card class="pa6" style="max-width:720px;width:100%">

          <!-- Alert -->
          <w-alert
            v-if="$message"
            error
            plain
            round
            dismiss
            class="mb4"
          >
            {{ $message }}
          </w-alert>

          <w-form @validate="simpan">

            <!-- Password Lama -->
            <w-input
              outline
              label="Kata Laluan Lama *"
              placeholder="Sila Masukkan Kata Laluan Lama"
              :type="isPassword2 ? 'password' : 'text'"
              :inner-icon-right="isPassword2 ? 'fal fa-eye-slash' : 'fal fa-eye'"
              @click:inner-icon-right="isPassword2 = !isPassword2"
              v-model="form.password_lama"
              :validators="[validators.required]"
              class="mb4"
            />

            <!-- Password Baru -->
            <w-tooltip right align-bottom color="white" bg-color="blue">
              <template #activator="{ on }">
                <span v-on="on">
                  <w-input
                    outline
                    label="Kata Laluan Baru *"
                    placeholder="Minimum 8 aksara"
                    :type="isPassword ? 'password' : 'text'"
                    :inner-icon-right="isPassword ? 'fal fa-eye-slash' : 'fal fa-eye'"
                    @click:inner-icon-right="isPassword = !isPassword"
                    v-model="form.password"
                    :validators="[validators.required]"
                    class="mb4"
                  />
                </span>
              </template>
              Minimum 8 aksara
            </w-tooltip>

            <!-- Pengesahan -->
            <w-tooltip right align-bottom color="white" bg-color="blue">
              <template #activator="{ on }">
                <span v-on="on">
                  <w-input
                    outline
                    label="Pengesahan Kata Laluan *"
                    placeholder="Sahkan Kata Laluan"
                    :type="isPassword1 ? 'password' : 'text'"
                    :inner-icon-right="isPassword1 ? 'fal fa-eye-slash' : 'fal fa-eye'"
                    @click:inner-icon-right="isPassword1 = !isPassword1"
                    v-model="form.password_confirmation"
                    :validators="[validators.required]"
                  />
                </span>
              </template>
              Pastikan kata laluan sama
            </w-tooltip>

            <!-- Error -->
            <div
              v-if="form.password && form.password_confirmation && form.password != form.password_confirmation"
              class="mt2"
              style="color:#ff5252;font-size:12px"
            >
              Kata Laluan tidak sepadan
            </div>

            <!-- Button -->
            <w-flex justify-end class="mt6">
              <w-button type="submit">
                <w-icon class="mr2" xs>fal fa-save</w-icon>
                SIMPAN
              </w-button>
            </w-flex>

          </w-form>

        </w-card>
      </w-flex>

    </z-page>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'

export default {
  extends: ZResource,
   props: {

    },
  data() {
    return {
        crumbs: [
          { label: this.$page.props.app_name, route: '/sitemap' },
          { label: 'Utama', route: '/' },
          { label: 'Kemaskini Kata Laluan', route: '/ubah-katalaluan' },
          { label: this.$page.props.auth.user.name , route: '/admin/user' }
        ],
        isPassword: true,
        isPassword1: true,
        isPassword2: true,
        files: [],
        attahecment : [], 
        country : [],
        bandar : [],
        negeri : [],
        poskod : [],
        form: {
          password_lama: '',
          password: '',
          password_confirmation: '',
        },
       
     
    }
  },
  methods: {
        
        simpan() {
            if(this.form.password != this.form.password_confirmation){
              this.$zutil.notifSweet('Sila Masukkan Password Pengesahan/Password Dengan Benar',
                        "error",
                    );
            }
            if (this.form.password == this.form.password_confirmation) {
            let params = {
                  id: this.$page.props.auth.user.id,
                  password_lama: this.form.password_lama,
                  pw: this.form.password,
                  password_confirmation: this.form.password_confirmation,
              };
              this.$zcomm.post('ubah-pw', params).then(res => {
                  if(res==2){
                     this.$zutil.notifSweet(
                           'Password lama tidak benar',
                           "error",
                       );
                  }else{
                     this.$zutil.notify(
                       "Kata laluan berjaya dikemaskini. Sila log masuk semula ke sistem",
                       true,
                       () => this.$inertia.post(route('logout'))
                     );
                     // this.$zutil.notify("Kata laluan berjaya dikemaskini. Sila log masuk semula ke sistem");
                     // this.$inertia.post(route('logout'));
                     // this.$inertia.visit(this.$route('home'));
                  }
                  
                })
                .catch((err) => {
                    this.$zutil.notifSweet(
                        'Password lama tidak benar',
                        "error",
                    );
                    console.error(err);
                })
                .finally(() => {
                    this.dialog.loading = false;
                })
                 .catch(err => {
                });
            }
        },
        
  },

  

  watch: {

  },
  mounted() {
    this.dialog.width = 500
      
  },
}
</script>
<style scoped>
  .w-card {
  border-radius: 10px;
}

.w-button {
  border-radius: 6px;
}
</style>
